import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { usePageTitle } from '@/hooks/usePageTitle';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotRecommend from './components/HotRecommend';
import LatestUpdate from './components/LatestUpdate';
import RankingSection from './components/RankingSection';

export default function Home() {
  const location = useLocation();

  usePageTitle('糖心影视 - 高清免费在线观看 | 最新电影电视剧全集');

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <HotRecommend />
        <LatestUpdate />
        <RankingSection />

        <section className="py-12 md:py-16 bg-background-50">
          <div className="px-4 md:px-6 max-w-7xl mx-auto text-center">
            <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-3">
              开启您的甜蜜观影之旅
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto mb-6">
              糖心影视汇聚全网高清影视资源，每日更新，即点即播。无论您喜欢什么类型的影片，都能在这里找到。
            </p>
            <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center text-accent-500">
                  <i className="ri-checkbox-circle-fill"></i>
                </div>
                <span className="text-sm text-foreground-700">海量资源</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center text-accent-500">
                  <i className="ri-checkbox-circle-fill"></i>
                </div>
                <span className="text-sm text-foreground-700">高清画质</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center text-accent-500">
                  <i className="ri-checkbox-circle-fill"></i>
                </div>
                <span className="text-sm text-foreground-700">流畅不卡顿</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center text-accent-500">
                  <i className="ri-checkbox-circle-fill"></i>
                </div>
                <span className="text-sm text-foreground-700">完全免费</span>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}